import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHubMainCompanion4 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(2.4 2.4) scale(0.7)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M7 16V8.4L2 3.4V6H0V0H6V2H3.4L9 7.6V16H7ZM10.85 6.6L9.4 5.15L12.6 2H10V0H16V6H14V3.4L10.85 6.6Z",
				fill: "#C2410C"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.2 4.4C2.0 5.9 2.0 10.1 3.2 11.6",
			stroke: "#F59E0B",
			strokeWidth: 1.25,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.1 5.5C3.4 6.6 3.4 9.4 4.1 10.5",
			stroke: "#F59E0B",
			strokeWidth: 1.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8 4.4C14.0 5.9 14.0 10.1 12.8 11.6",
			stroke: "#F59E0B",
			strokeWidth: 1.25,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9 5.5C12.6 6.6 12.6 9.4 11.9 10.5",
			stroke: "#F59E0B",
			strokeWidth: 1.1,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgHubMainCompanion4);
export { ForwardRef as ReactComponent };
